import NewInvoiceItemTableRow from './NewInvoiceItemTableRow';
import intl from 'components/i18n/ReactIntlWrapper';
import { useInvoice } from '../common/InvoiceProvider';
import { Table, TableHead, TableBody, TableRow, TableCell, Button } from '@mui/material';

const NewInvoiceItemTable = ({ disabled }) => {
  const { setInput, input, setErrors, errors } = useInvoice();
  const handleInputItemTableChange = function (e) {
    const id = Number(e.target.name.split('[')[1].split(']')[0]);
    const category = e.target.name.split('[')[0];
    setInput((prev) => ({
      ...prev,
      invoiceItems: prev?.invoiceItems?.map((item) => {
        if (item.id !== id) return item;
        const updated = { ...item, [category]: e.target.value };
        updated['amount'] = (Number(updated.rate) * Number(updated.quantity)).toFixed(2);
        if (isNaN(Number(updated['amount']))) updated['amount'] = 0;
        return updated;
      }),
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`invoiceItems`]: '',
      [`invoiceItems[${id}].${category}`]: '',
    }));
  };

  const handleDelete = function (id) {
    const newItems = input.invoiceItems.filter((item) => item.id !== id);
    setInput({
      ...input,
      invoiceItems: newItems,
    });
  };

  const handleNewRow = function () {
    let latestsId = 0;
    if (input.invoiceItems[0]) {
      latestsId = input.invoiceItems[input.invoiceItems.length - 1]['id'];
    }
    const newItem = {
      id: latestsId + 1,
      amount: '',
      unit: 1,
      invoiceItemTaxes: [],
    };
    setInput({
      ...input,
      invoiceItems: [...input.invoiceItems, { ...newItem }],
    });
  };

  return (
    <div className="table-responsive my-2">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={'40%'} className="black-header">
              {intl.get('newInvoice.desctiption')}
            </TableCell>
            <TableCell className="black-header">{intl.get('newInvoice.qty')}</TableCell>
            <TableCell className="black-header">{intl.get('newInvoice.rate')}</TableCell>
            <TableCell width={'25%'} className="black-header">
              {intl.get('newInvoice.amount')}
            </TableCell>
          </TableRow>
        </TableHead>
        {input.invoiceItems !== null && (
          <TableBody>
            {input?.invoiceItems?.map((e, i) => (
              <NewInvoiceItemTableRow
                key={e.id}
                id={e.id}
                description={e.description}
                quantity={e.quantity}
                invoiceItemTaxes={e.invoiceItemTaxes}
                taxesValues={input.taxes}
                rate={e.rate}
                amount={e.amount}
                className={i % 2 > 0 ? '' : 'odd'}
                handleInputItemTableChange={(e) => handleInputItemTableChange(e)}
                handleDelete={(id) => handleDelete(id)}
                disabled={disabled}
              />
            ))}
            <TableRow>
              <TableCell colSpan={6} align="left">
                <Button
                  variant="text"
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={handleNewRow}
                  disabled={disabled}
                >
                  +{intl.get('newInvoice.add.new.row')}
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    </div>
  );
};

export default NewInvoiceItemTable;
